export function isFilterKey(key: string): boolean {
    const filterprefix = 'filter_';
    return (
        key.substr(0, filterprefix.length) === filterprefix &&
        key !== 'filter_family' &&
        key !== 'filter_foundry'
    );
}